import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';
import {GetOdontoProviderAddress} from 'domain/usecases';
import {RemoteGetOdontoProviderAddress} from 'data/usecases';

export const makeGetOdontoProviderAddress = (): GetOdontoProviderAddress =>
	new RemoteGetOdontoProviderAddress(
		makeBFFApiUrl(BookingFlowEndPoints.odontoProviderAddress),
		makeAuthorizeHttpClientDecorator(),
	);
